import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import {CATALOGO_UNIDADES} from '@/constantes/catalogos/unidades'
import { UUID } from '../../constantes/helpers'

const db = firebase.firestore()
function titleCase(string){
    if(string){
        return string[0].toUpperCase() + string.slice(1).toLowerCase();
    }
    return '';
  }
  function abreviaturaCase(string){
    if(string){
        return string.toLowerCase();
    }
    return '';
  }
const store = {
    state: {
        catalogoUnidades: [],
    },
    getters: {
        catalogoUnidades: state => {
            return state.catalogoUnidades
        },
        catalogoUnidadesOptions: state => {
            
            let lista = [];
            for(let i in state.catalogoUnidades){
                let item = state.catalogoUnidades[i];
                if(item.activo){
                    let texto = titleCase(item.descripcion) + ' ('+ abreviaturaCase(item.abreviatura) +')';
                    lista.push(texto);
                }
            }
            //console.log('unicades dinamicas', state.catalogoUnidades)
            return lista
        },
    },
    mutations: {
        ASIGNA_CATALOGO_UNIDADES(state, catalogoUnidades) {
            state.catalogoUnidades = catalogoUnidades
        },
    },
    actions: {

        obtenerUnidades({ getters, commit, dispatch }) {

            return new Promise((resolve) => {

                db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                    .collection(FS_COLLECTIONS.CATALOGOS).doc(FS_COLLECTIONS.UNIDADES)
                    .onSnapshot(doc => {
                        //TODO:Mejorar aquí
                        if(!doc.data()){
                            commit('ASIGNA_CATALOGO_UNIDADES', [])
                            dispatch('guardarCatalogoInicialUnidades').then(() => {
                                resolve()
                            }).catch(e => {
                                reject(e)
                            })
                        } else {
                            console.log("Data unidades ", doc.data() )
                            commit('ASIGNA_CATALOGO_UNIDADES', doc.data().Unidades)
                            resolve()
                        }

                    }
                )

            })

        },
        async guardarUnidad({getters,dispatch}, props){

            const {id, unidad} = props
            let unidades = getters.catalogoUnidades

            try {

                if(!id){
                    //Unidad nueva
                    unidad.id = UUID()
                    unidades.push(unidad)
                } else {
                    //Actualizar unidad
                    for(const i in unidades){
                        (unidades[i].id===id) && (unidades[i] = unidad)
                    }

                }

                await dispatch('actualizarCatalogoUnidades',{Unidades:unidades})

                return true;

            } catch(e){

                throw e

            }

        },
        eliminarUnidad({dispatch,getters},id){

            return new Promise((resolve,reject) => {

                let unidades = getters.catalogoUnidades
                unidades = unidades.filter(e=>e.id!==id)
                
                dispatch('actualizarCatalogoUnidades',{Unidades:unidades}).then(() => {
                    resolve()
                }).catch(e => {
                    reject(e)
                })

            })

        },
        async guardarCatalogoInicialUnidades({dispatch}){

            const unidades = {Unidades:[]}

            for(const i in CATALOGO_UNIDADES.Unidades){

                const unidad = CATALOGO_UNIDADES.Unidades[i]
                unidad.fecha_alta = new Date()
                unidades.Unidades[i] = unidad

            }

            try {

                await dispatch('actualizarCatalogoUnidades',unidades)

                return true;

            } catch(e){
                
                throw e

            }

        },
        actualizarCatalogoUnidades({getters},unidades){

            return new Promise((resolve,reject) => {

                db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                .collection(FS_COLLECTIONS.CATALOGOS).doc(FS_COLLECTIONS.UNIDADES)
                .set(unidades).then(() => {
                    resolve()
                }).catch(e => {
                    reject(e)
                })

            })

        }

    }
}

export default store



// WEBPACK FOOTER //
// ./src/store/unidades/index.js